import { render, staticRenderFns } from "./NewNote.vue?vue&type=template&id=45ae4a8d&scoped=true&"
import script from "./NewNote.vue?vue&type=script&lang=js&"
export * from "./NewNote.vue?vue&type=script&lang=js&"
import style0 from "./NewNote.vue?vue&type=style&index=0&id=45ae4a8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ae4a8d",
  null
  
)

export default component.exports